import { render, staticRenderFns } from "./SetupProjectOrganisationStep.vue?vue&type=template&id=f5de870e&"
import script from "./SetupProjectOrganisationStep.vue?vue&type=script&lang=ts&"
export * from "./SetupProjectOrganisationStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
